import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// CertificateDocument is laid out at exactly A4 proportions (794 x 1123 px), so
// the capture drops onto one A4 page without any scaling maths or page breaks.
export const certificateNodeToPdf = async (node) => {
  const canvas = await html2canvas(node, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });

  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, pageWidth, pageHeight);
  return pdf;
};

export const certificateFileName = (certificate, extension = 'pdf') =>
  `${certificate?.certificateNo || 'certificate'}-${(certificate?.patientName || 'patient').replace(/\s+/g, '-')}.${extension}`;
